import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import { endpoints } from "../../../../hooks/endpoints";
import { getToken } from "../../../../hooks/utils";
import { useAppSelector } from "../../../../store/hooks";
import { LiveSessionDataI } from "../../../quiz/typesAndEnums";

const useGetLiveSession = () => {
  const { session } = useParams();
  const [sessionData, setSessionData] = useState<LiveSessionDataI | null>(null);
  const { user, userProfileData } = useAppSelector((state) => state.store);

  const fetchData = useCallback(async () => {
    try {
      const response = await fetch(
        `${endpoints.getLiveSession}?session=${session}&ts=${Date.now()}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: getToken(),
          },
          method: "GET",
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      return data as LiveSessionDataI;
    } catch (err) {
      console.log(err);
      return null;
    }
  }, []);

  useEffect(() => {
    if (!user) return;

    fetchData().then((data) => {
      setSessionData(data);
    });
  }, [user, userProfileData]);

  return sessionData;
};

export default useGetLiveSession;
